
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppFileUpload, AppImageHolder, AppButton } from '@/components';
import { usePromotionItemEdit } from '@/modules/promotion/item/model/edit';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';

export default defineComponent({
    name: ROUTE_NAME_PROMOTION.ITEM.EDIT,
    components: { AppFormRow, AppInput, AppCard, AppFileUpload, AppImageHolder, AppButton },
    setup() {
        const { model, v$, fetch, update } = usePromotionItemEdit();

        onMounted(async () => {
            await fetch();
        });

        return { v$, model, update };
    }
});
